import styled from 'styled-components';

export const ModalFooter = styled.div(({
  theme: {
    modal,
    indents,
  },
}) => ({
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  paddingBottom: indents.INDENT_2,
  marginTop: indents.INDENT_3,
  borderTop: modal.FOOTER_BORDER_TOP,
}));
